import { Info } from '@mui/icons-material';
import { Divider, Stack, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { type InvoiceItemType } from '../types/invoice.type';

interface InvoiceVatMessageProps {
  invoiceItems: InvoiceItemType[];
}

// Note: This file is duplicated in portal. It would be nice to keep them nearly in sync.
export const InvoiceVatMessage = ({ invoiceItems }: InvoiceVatMessageProps) => {
  const { t } = useTranslation('settings');

  const hasRoyalMailItem = invoiceItems.some((item) => item.provider_name === 'Royal Mail SF');
  if (!hasRoyalMailItem) return null;

  return (
    <tr>
      <td colSpan={4} />
      <td colSpan={2}>
        <Divider textAlign="right" />
        <Stack
          alignItems="center"
          direction="row"
          gap={1}
          justifyContent="flex-end"
          marginRight="8px"
        >
          <Typography color="black" fontWeight={700} variant="inherit">
            {t('account.billing.invoices.download.invoiceItemsTable.vatNotIncluded')}
          </Typography>
          <Tooltip
            placement="top-end"
            role="tooltip"
            title={
              <Typography color="inherit" variant="caption">
                <b style={{ fontWeight: 700 }}>
                  {t('account.billing.invoices.download.invoiceItemsTable.vatNotIncluded')}
                </b>
                <br />
                {t('account.billing.invoices.download.invoiceItemsTable.vatNotIncludedExplanation')}
              </Typography>
            }
          >
            <Info color="secondary" fontSize="small" />
          </Tooltip>
        </Stack>
      </td>
    </tr>
  );
};
